import React from 'react';

import { SectionTitle } from '../../elements/SectionTitle/SectionTitle';
import type { YouTubeVideoProps } from '../../elements/YouTubeVideo/types';
import { YouTubeVideo } from '../../elements/YouTubeVideo/YouTubeVideo';
import * as styles from './YouTubeVideoBlock.styles';

export interface YouTubeVideoBlockProps extends Omit<YouTubeVideoProps, 'videoDescription'> {
  caption?: string;
  title?: string;
}

export const YouTubeVideoBlock = ({ caption, title, ...props }: YouTubeVideoBlockProps) => (
  <div css={styles.wrapper}>
    {title && (
      <div css={styles.title}>
        <SectionTitle title={title} />
      </div>
    )}
    <YouTubeVideo {...props} videoDescription={title || caption} />
    {caption && <p css={styles.caption}>{caption}</p>}
  </div>
);
